import React, { useMemo } from 'react'
import { AgreementsData } from '../GeneralInformation/typesExtendedReport'


export const useAgreementsData = (data: AgreementsData | null | undefined) => {

    return useMemo(() => {
        if (!data) return null

        return {
            Lon: data.lon,
            Tcp: data.tcp,
            Igr: data.igr
        }
    }, [data])
}
